module.exports = __webpack_public_path__ + "img/login_banner.c1da66d8.jpg";